/* App overrides — Timesact Pre-Order widgets on the product page.
   1. "Notify Me": the app injects <button class="timesact-backInStock-button" style="...!important">
      into .dm-buy with inline !important styles (black fill, 10px radius, 100% width) that no
      stylesheet rule can outrank. The style attribute is stripped and the control gets the theme's
      secondary button classes (.dm-btn.dm-btn--outline).
   2. Labels: the app writes "Pre-Order" into the theme's ADD_TO_CART button and "Notify Me" into its
      own control; both are rewritten in the theme's terminal style ([ >_ PRE_ORDER ], [ NOTIFY_ME ]).
      Any other wording the app may use (e.g. a translation) is left untouched.
   A MutationObserver repeats both whenever the app re-renders (it does so after every variant
   change). Everything else about the widgets is handled in base.css ("App overrides: Timesact"). */
(function () {
  'use strict';

  var NOTIFY_SELECTOR = '.timesact-backInStock-button';
  var THEME_CLASSES = ['dm-btn', 'dm-btn--outline'];
  var LABELS = [
    { selector: 'button[name="add"]', test: /^pre-?\s?order$/i, label: '[ >_ PRE_ORDER ]' },
    /* The app also rewrites the button on variants it has no pre-order config for —
       PERSONAL NODE, added with the dual-license migration — replacing the theme's
       label with its own "Add to cart". Put the terminal wording back. */
    { selector: 'button[name="add"]', test: /^add to cart$/i, label: '[ >_ ADD_TO_CART ]' },
    { selector: NOTIFY_SELECTOR, test: /^notify\s?me$/i, label: '[ NOTIFY_ME ]' }
  ];

  function themeButton(el) {
    if (el.hasAttribute('style')) el.removeAttribute('style');
    THEME_CLASSES.forEach(function (c) { el.classList.add(c); });
  }

  function sweep(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(NOTIFY_SELECTOR)) themeButton(node);
    node.querySelectorAll(NOTIFY_SELECTOR).forEach(themeButton);
  }

  function relabel(scope) {
    LABELS.forEach(function (rule) {
      scope.querySelectorAll(rule.selector).forEach(function (el) {
        var text = el.textContent.trim();
        if (rule.test.test(text) && text !== rule.label) el.textContent = rule.label;
      });
    });
  }

  function init() {
    var scope = document.querySelector('.dm-product__info');
    if (!scope) return;
    sweep(scope);
    relabel(scope);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes') {
          if (m.target.matches(NOTIFY_SELECTOR) && m.target.hasAttribute('style')) themeButton(m.target);
        } else if (m.type === 'childList') {
          m.addedNodes.forEach(sweep);
        }
      });
      relabel(scope);
    }).observe(scope, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
